import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const X = (props) => (
  <Icon viewBox="0 0 10 10" {...props}>
    <g>
      <title>x</title>
      <g fill="currentColor" fillRule="nonzero">
        <path d="M9.081.596L.596 9.081a.5.5 0 1 0 .707.708L9.79 1.303A.5.5 0 0 0 9.08.596z" />
        <path d="M9.789 9.081L1.303.596a.5.5 0 0 0-.707.707L9.081 9.79a.5.5 0 1 0 .708-.708z" />
      </g>
    </g>
  </Icon>
);
/*eslint-enable */

export default X;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/X.js